import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton affiché pendant le chargement des routes lazy (Suspense fallback).
 * Reprend la structure générique : navbar + zone de contenu pour une UX premium.
 */
export function RouteLoaderSkeleton() {
  return (
    <div className="min-h-screen bg-scandi-bg flex flex-col" aria-hidden="true">
      {/* Navbar skeleton */}
      <header className="sticky top-0 z-50 w-full border-b border-border bg-scandi-surface">
        <div className="container mx-auto px-4 h-14 md:h-16 flex items-center justify-between">
          <Skeleton className="h-8 w-28 md:w-32 rounded-lg" />
          <div className="flex items-center gap-2 md:gap-4">
            <Skeleton className="h-9 w-16 md:w-20 rounded-lg" />
            <Skeleton className="h-9 w-16 md:w-20 rounded-lg" />
            <Skeleton className="h-9 w-9 rounded-lg" />
          </div>
        </div>
      </header>

      {/* Content skeleton */}
      <main className="flex-1 container mx-auto px-4 py-6 md:py-8 space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48 md:w-64" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-48 md:h-56 rounded-xl" />
          ))}
        </div>
      </main>
    </div>
  );
}
